import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from '@mui/material';
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, deleteTransactionMaster } from '../../graphql/mutations';
import { LoadingButton } from "@mui/lab";
import { showSuccessSnackbar } from "../snackBar/snakbar";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const DeleteSelectedEntry = ({ open, setOpen, itemsData, rows, setRows }) => {
    const [finishedArr, setFinishedArr] = useState([])
    const [loading, setLoading] = useState(false);

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    async function deleteGoodsItemDet(data) {
        try {
            const res = await API.graphql(
                graphqlOperation(deleteTransactionMaster, { TransactionID: data })
            )
            if (res.data?.deleteTransactionMaster != null) {
                setFinishedArr(prev => ([
                    ...prev,
                    true
                ]))
            } else {
                setFinishedArr(prev => ([
                    ...prev,
                    false
                ]))
            }
            // console.log(res);
        } catch (error) {
            console.log(error);
        }

    }

    useEffect(() => {
        if (itemsData?.length > 0) {
            if (finishedArr.length == itemsData?.length) {
                let arr = rows.filter((item, ind) => {
                    if (!itemsData.includes(item?.TransactionID)) {
                        return item
                    }
                })
                setRows(arr)
                setOpen(false)
                showSuccessSnackbar("Entry deleted Successfully")
                setLoading(false)
            }
        }
    }, [finishedArr])

    const deleteItem = () => {
        if (itemsData?.length > 0) {
            setLoading(true)
            itemsData.map((item) => {
                deleteGoodsItemDet(item)
            })

        }
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Box sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    backgroundColor: "white",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this item?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button onClick={handleClose} disabled={loading} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
                    <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                        Yes
                    </LoadingButton>
                </Box>


            </Box>
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteSelectedEntry;